


























import Vue from 'vue';
import { mapGetters } from 'vuex';
import PageColorPickerModal from '@/web/views/admin/pages/PageColorPickerModal.vue';
import i18n from '@/web/utils/localization';

export default Vue.extend({
  name: 'PageStyle',
  data() {
    return {
      colorsData: [
        {
          key: 'emphasis_color',
          label: i18n.t('PAGES.LABEL.EMPHASIS_COLOR'),
        },
        {
          key: 'darkest_color',
          label: i18n.t('PAGES.LABEL.DARKEST_COLOR'),
        },
        {
          key: 'medium_color',
          label: i18n.t('PAGES.LABEL.MEDIUM_COLOR'),
        },
        {
          key: 'light_color',
          label: i18n.t('PAGES.LABEL.LIGHT_COLOR'),
        },
        {
          key: 'lightest_color',
          label: i18n.t('PAGES.LABEL.LIGHTEST_COLOR'),
        },
      ],
      pageForm: undefined,
    };
  },
  computed: {
    ...mapGetters({
      page: 'page/page',
      pageColors: 'page/pageColors',
    }),
  },
  methods: {
    async save() {
      await this.$store.dispatch('page/updatePage', {
        id: this.page.id,
        data: { ...this.pageForm },
      });
      this.$emit('close');
    },
    openColorPicker(colorKey) {
      const color = this.pageForm?.[colorKey];

      this.$modal.show(
        PageColorPickerModal,
        {
          inputColor: color,
          customColors: this.pageColors,
        },
        {
          classes: ['vm--color-picker-modal'],
        },
        {
          'color-selected': color => {
            this.pageForm[colorKey] = color;
          },
        }
      );
    },
  },
  mounted() {
    this.pageForm = JSON.parse(JSON.stringify(this.page));
  },
});
